import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@material-ui/core";
import AppsIcon from "@material-ui/icons/Apps";
import ViewHeadlineIcon from "@material-ui/icons/ViewHeadline";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export const STUDENTS_VIEW_LIST = "list";
export const STUDENTS_VIEW_GRID = "grid";
export const STUDENTS_VIEW_STORAGE_KEY = "classDiary.classStudentsListView";

const Switch = styled.div`
  display: inline-flex;
  align-items: stretch;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
`;

const SwitchButton = styled(IconButton)`
  && {
    padding: 6px 8px;
    border-radius: 0;
    color: ${({ $active, theme }) =>
      $active ? theme.color.secondary.dark : theme.color.default.main};
    background: ${({ $active, theme }) =>
      $active ? theme.color.primary.light : "transparent"};
  }
  && + && {
    border-left: 1px solid #e0e0e0;
  }
  && svg {
    font-size: 22px;
  }
`;

export function readStoredStudentsView() {
  try {
    const stored = window.localStorage.getItem(STUDENTS_VIEW_STORAGE_KEY);
    if (stored === STUDENTS_VIEW_LIST || stored === STUDENTS_VIEW_GRID) {
      return stored;
    }
  } catch (e) {
    console.error(e);
  }
  return STUDENTS_VIEW_GRID;
}

export function persistStudentsView(view) {
  try {
    window.localStorage.setItem(STUDENTS_VIEW_STORAGE_KEY, view);
  } catch (e) {
    console.error(e);
  }
}

const ClassStudentsListViewToggle = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <Switch role="group" aria-label={t("classes.details.studentsViewAria")}>
      <SwitchButton
        $active={value === STUDENTS_VIEW_GRID}
        aria-pressed={value === STUDENTS_VIEW_GRID}
        aria-label={t("classes.details.viewGrid")}
        title={t("classes.details.viewGrid")}
        onClick={() => onChange(STUDENTS_VIEW_GRID)}
      >
        <AppsIcon />
      </SwitchButton>
      <SwitchButton
        $active={value === STUDENTS_VIEW_LIST}
        aria-pressed={value === STUDENTS_VIEW_LIST}
        aria-label={t("classes.details.viewList")}
        title={t("classes.details.viewList")}
        onClick={() => onChange(STUDENTS_VIEW_LIST)}
      >
        <ViewHeadlineIcon />
      </SwitchButton>
    </Switch>
  );
};

ClassStudentsListViewToggle.propTypes = {
  value: PropTypes.oneOf([STUDENTS_VIEW_LIST, STUDENTS_VIEW_GRID])
    .isRequired,
  onChange: PropTypes.func.isRequired
};

export default ClassStudentsListViewToggle;
